<template>
    <div class="sort-select-container">
      <div class="sort-select" @click="toggleDropdown">
        <div class="select-value">{{ currentLabel }}</div>
        <div class="select-arrow" :class="{ 'open': isOpen }">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="select-dropdown" v-if="isOpen">
        <div class="select-label" v-if="label">{{ label }}</div>
        <div 
          v-for="option in options" 
          :key="option.value" 
          class="select-option" 
          :class="{ 'selected': value === option.value }"
          @click="selectOption(option.value)"
        >
          {{ option.label }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SortSelect",
    props: {
      // Options du sélecteur
      options: {
        type: Array,
        required: true,
        // Structure attendue: [{ value: 'value1', label: 'Label 1' }, ...]
      },
      // Valeur actuellement sélectionnée
      value: {
        type: [String, Number],
        required: true
      },
      // Label optionnel à afficher au-dessus des options
      label: {
        type: String,
        default: ""
      },
      // Taille (sm, md, lg)
      size: {
        type: String,
        default: "md",
        validator: (val) => ["sm", "md", "lg"].includes(val)
      }
    },
    data() {
      return {
        isOpen: false
      };
    },
    computed: {
      // Récupère le label correspondant à la valeur sélectionnée
      currentLabel() {
        const option = this.options.find(opt => opt.value === this.value);
        return option ? option.label : "";
      }
    },
    mounted() {
      // Ajoute un gestionnaire de clic global (pour fermer le dropdown lorsqu'on clique ailleurs)
      document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
      // Nettoyage du gestionnaire lors de la destruction du composant
      document.removeEventListener('click', this.handleOutsideClick);
    },
    methods: {
      // Ouvre/ferme le dropdown
      toggleDropdown() {
        this.isOpen = !this.isOpen;
      },
      
      // Ferme le dropdown si on clique en dehors
      handleOutsideClick(event) {
        if (this.isOpen && !this.$el.contains(event.target)) {
          this.isOpen = false;
        }
      },
      
      // Sélectionne une option et émet l'événement change
      selectOption(value) {
        this.isOpen = false;
        if (this.value !== value) {
          this.$emit('input', value);
          this.$emit('change', value);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .sort-select-container {
    position: relative;
    min-width: 160px;
    font-family: sans-serif;
  }
  
  .sort-select {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px 20px;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
  }
  
  .sort-select:hover {
    border-color: #d0d0d0;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);
  }
  
  /* Tailles différentes */
  .sort-select-container.size-sm .sort-select {
    padding: 8px 16px;
    font-size: 12px;
  }
  
  .sort-select-container.size-lg .sort-select {
    padding: 14px 24px;
    font-size: 16px;
  }
  
  .select-label {
    font-size: 11px;
    color: #666;
    font-weight: normal;
    padding: 12px 20px;
  }
  
  .select-value {
    font-weight: 500;
    color: #000;
  }
  
  .select-arrow {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    transition: transform 0.2s ease;
    color: #333;
  }
  
  .select-arrow.open {
    transform: translateY(-50%) rotate(180deg);
  }
  
  .select-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 10;
    overflow: hidden;
  }
  
  .select-option {
    padding: 12px 20px;
    cursor: pointer;
    transition: background 0.2s ease;
    font-size: 14px;
  }
  
  .select-option:hover {
    background: #f5f5f5;
  }
  
  .select-option.selected {
    background: #f0f0f0;
    font-weight: 500;
  }
  </style>